module.exports = __webpack_public_path__ + "img/produto-favorito-check.f75140d0.svg";